export default __webpack_public_path__ + "static/media/tavi_main_large.bd242c37.jpg";